import type { Highlight } from './contracts';
import { renderableHighlights } from './normalize';
import type { PresentationGraphExtension } from './contracts';

/** SPEC-011 §44-48/plan §22-24 — pure Previous/Next stepping over renderable (non-empty) highlights, ordered by `order`. */
export function orderedRenderableHighlights(config: PresentationGraphExtension): Highlight[] {
  return [...renderableHighlights(config)].sort((a, b) => a.order - b.order);
}

export function nextHighlightId(
  config: PresentationGraphExtension,
  currentId: string | null,
): string | null {
  const ordered = orderedRenderableHighlights(config);
  if (ordered.length === 0) return null;
  if (currentId === null) return ordered[0]!.id;
  const index = ordered.findIndex((h) => h.id === currentId);
  if (index === -1) return ordered[0]!.id;
  return ordered[(index + 1) % ordered.length]!.id;
}

export function previousHighlightId(
  config: PresentationGraphExtension,
  currentId: string | null,
): string | null {
  const ordered = orderedRenderableHighlights(config);
  if (ordered.length === 0) return null;
  if (currentId === null) return ordered[ordered.length - 1]!.id;
  const index = ordered.findIndex((h) => h.id === currentId);
  if (index === -1) return ordered[0]!.id;
  return ordered[(index - 1 + ordered.length) % ordered.length]!.id;
}
